import { useFlags } from '@atlaskit/flag';
import { useDialog } from 'core/providers/DialogProvider';
import { useState } from 'react';
import { IButton } from 'shared/components/buttons/button-interface';
import SharedDialogBase from 'shared/components/dialog-base/dialog-base';
import SharedForm from 'shared/components/form/form';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { showErrorFlag, showSuccessFlag } from 'core/utilities/flags-helper';
import { IExportDeliveriesDialogFormOutput } from 'modules/deliveries/export-deliveries-dialog/export-deliveries-dialog-interface';
import { ExportDeliveriesDialogFormFields } from 'core/config/form-fields';
import { TransportJobsApiService } from 'core/api';
dayjs.extend(customParseFormat);

const ExportTransportJosbDialog = () => {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [error, setError] = useState<string>();

  const flags = useFlags();
  const dialog = useDialog();

  const exportCsv = async (startDateString: string, endDateString: string) => {
    const csv: string = await TransportJobsApiService.export(startDateString, endDateString, 'csv');
    const blob = new Blob(['\ufeff', csv]);
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = `d_hive_jobs_${startDateString}_to_${endDateString}.csv`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const exportSuccessfulDeliveriesPdf = async (startDateString: string, endDateString: string) => {
    const signedUrl: string = await TransportJobsApiService.export(startDateString, endDateString, 'pdf');
    window.open(signedUrl);
  };

  const submit = async (data: IExportDeliveriesDialogFormOutput) => {
    setError(undefined);
    setFormSubmitting(true);
    const { startDateString, endDateString, exportType } = data;
    if (startDateString > endDateString) {
      setError('Start date must be set after end date');
      setFormSubmitting(false);
      return;
    }

    try {
      if (exportType.value === 'csv') {
        await exportCsv(startDateString, endDateString);
      } else {
        await exportSuccessfulDeliveriesPdf(startDateString, endDateString);
      }
      showSuccessFlag('Export successful', 'The jobs were successfully exported', flags);
      dialog?.closeDialog();
    } catch (error) {
      setFormSubmitting(false);
      showErrorFlag('Export failed', 'The export failed, please try again.', flags);
    }
  };

  const cancelButton: IButton = {
    onClick: () => dialog?.closeDialog(),
    label: 'Cancel',
    appearance: 'subtle',
    type: 'button',
  };

  const customContent = () => {
    return (
      <SharedForm
        className='p-4 overflow-y-auto'
        onSubmit={submit}
        fields={ExportDeliveriesDialogFormFields}
        buttonLabel='Submit'
        loading={formSubmitting}
        cancelButton={cancelButton}
        formErrorMessage={error}
      />
    );
  };

  return <SharedDialogBase title='Export jobs' customContentTemplate={customContent()} showButtons={false} />;
};

export default ExportTransportJosbDialog;
